<template>
  <div>
    <div class="bg-white mb-4 border border-border rounded-md block lg:hidden">
      <h6 class="card-title p-4 border-b border-border !m-0">Information Regarding Dependent Coverage</h6>
      <div class="p-4">
        <div class="mb-5">
          <p class="content">
            Once you enroll and your membership is activated, you will be able to add spouse/domestic partner and/or
            dependents if your policy provides for the additional coverage. You may do this by registering on the
            Member Portal. Instructions will be included in your Welcome Letter that you will receive after
            activation.
            <br>
            <br><b class="text-black">Please note</b>, if you are enrolling in an individual only plan, your
            dependents will not be eligible for coverage.
          </p>
        </div>
      </div>
    </div>
    <div class="mb-4 border border-border rounded-md block lg:hidden">
      <button @click="toggleAccordion(1)" class="bg-white flex items-center justify-between w-full p-4 font-bold rtl:text-right rounded-md focus:ring-0 focus:ring-gray-200 
      gap-3 rounded-t-lg !text-blackPrimary">
        <span>Disclaimer</span>
        <span id="icon-1" class="text-slate-800 transition-transform duration-300">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
            <path fill-rule="evenodd"
              d="M11.78 9.78a.75.75 0 0 1-1.06 0L8 7.06 5.28 9.78a.75.75 0 0 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06Z"
              clip-rule="evenodd" />
          </svg>
        </span>
      </button>
      <div id="content-1"
        class="max-h-0 overflow-hidden transition-all duration-300 ease-in-out bg-white rounded-b-lg border-t border-border">
        <div class="p-4">
          <div v-if="
            state.enrollment_settings.disclaimer_text != '' &&
            state.enrollment_settings.disclaimer_text != null
          " class="content" id="viewer1"></div>
        </div>
      </div>
    </div>
    <div class="form-group mb-5">
      <small class="mt-[8px] block text-mute text-xs font-normal flex"
        v-if="state.enrollment_settings.e_sign_text != '' && state.enrollment_settings.e_sign_text != null">
        <img src="@/assets/images/info.svg" alt="info" height="18px" width="18px">
        <span class="px-2">{{ state.enrollment_settings.e_sign_text }}</span>
      </small>
      <label class="font-normal text-mute text-sm mb-2 inline-block mt-[8px]"> Electronic Signature {{ formattedDate }}
        (Type Full Name)<span class="text-error">*</span></label>
      <input type="text" placeholder="Enter Your Full Name" class="form" v-model="localForm.eSignature"
        @blur="updateParent('eSignature')" />
      <small v-if="validation.user_form.eSignature.$error" class="text-error text-xs">
        Signature is required.
      </small>
    </div>
    <div class="form-group mb-5">
      <label class="font-normal text-mute text-sm mb-2 inline-block mt-[8px]"> Type in "I AGREE" to verify you agree to
        the terms listed on this enrollment<span class="text-error">*</span></label>
      <input type="text" placeholder="Type I AGREE" class="form" v-model="localForm.iagree"
        @blur="updateParent('iagree')" />
      <small v-if="validation.user_form.iagree.$error" class="text-error text-xs">
        Agree first before proceeding.
      </small>
    </div>
    <div class="flex items-start justify-start gap-4 mt-4">
      <button class="primary-button" :disabled="validation.$invalid || localForm.iagree != 'I AGREE' || submitting"
        @click="submitForm">Submit</button>
      <button class="primary-outline-button" @click="resetForm">reset</button>
    </div>
  </div>
</template>

<script>

export default {
  name: "SignatureSection",
  props: {
    user_form: {
      type: Object,
    },
    validation: {
      type: Object
    },
    state: {
      type: Object
    }
  },
  data() {
    return {
      formattedDate: new Date().toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      }),
      localForm: this.user_form, // Create a local copy of the form
      validationState: {},
      submitting: false
    };
  },
  methods: {
    toggleAccordion(index) {
      const content = document.getElementById(`content-${index}`);
      const icon = document.getElementById(`icon-${index}`);

      // SVG for Down icon
      const downSVG = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
        <path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
      </svg>
    `;

      // SVG for Up icon
      const upSVG = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
        <path fill-rule="evenodd" d="M11.78 9.78a.75.75 0 0 1-1.06 0L8 7.06 5.28 9.78a.75.75 0 0 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06Z" clip-rule="evenodd" />
      </svg>
    `;

      // Toggle the content's max-height for smooth opening and closing
      if (content.style.maxHeight && content.style.maxHeight !== '0px') {
        content.style.maxHeight = '0';
        icon.innerHTML = upSVG;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.innerHTML = downSVG;
      }
    },
    updateParent(field) {
      // Emit the updated value to the parent
      this.$emit("update:user_form", {
        ...this.localForm,
        [field]: this.localForm[field],
      });
      if (this.validation.user_form[field]?.$touch) {
        this.validation.user_form[field].$touch();
      }
      const hasError = this.validation.user_form[field]?.$error || false;
      this.validationState[field] = hasError;
    },
    submitForm() {
      console.log('click')
      if (this.submitting) return; // prevent multiple clicks
      this.submitting = true;
      this.$emit("createMember", (response) => {
        console.log(response,'comp response')
        // Re-enable the button if there was an error or submission finished
        if (!response || response.data?.status !== "success") {
        this.submitting = false;
      } 
        // success = true means submission was successful, keep it disabled
        // success = false means error, enable button
      });
    },
    resetForm() {
      this.$emit("resetForm");
    }
  }
};
</script>

<style scoped>
/* Add any necessary styles here */
</style>